import type { Chart } from "chart.js";

const defaultFont = { size: 14, style: "normal", family: "Helvetica Neue" };
const warningFont = { size: 12, style: "bold", family: "Helvetica Neue" };

export default function drawInclinationLabel(chart: Chart, font: Partial<typeof defaultFont> = {}): void {
  const ctx = chart.ctx;
  const chartArea = chart.chartArea;
  const selectedFont = { ...defaultFont, ...font };

  chart.data.datasets.forEach((dataset, datasetIndex) => {
    const meta = chart.getDatasetMeta(datasetIndex);
    if (!chart.isDatasetVisible(datasetIndex)) {
      return;
    }

    meta.data.forEach((element, index) => {
      if (index === 0) {
        return;
      }

      const point = (dataset.data[index] as { metadata?: Record<string, unknown> } | undefined) ?? {};
      const metadata = point.metadata ?? {};
      const inclination = metadata.inclination as string | undefined;
      const inclinationWarning = metadata.inclinationWarning as boolean | undefined;

      if (!inclination) {
        return;
      }

      const prevElement = meta.data[index - 1] as { x: number; y: number };
      const currElement = element as { x: number; y: number };

      const x = (currElement.x + prevElement.x) / 2;
      const y = (currElement.y + prevElement.y) / 2;
      const padding = 4;
      const diameter = 6;
      const width = ctx.measureText(inclination).width;

      if (chartArea.top < y && chartArea.bottom > y && chartArea.left < x && chartArea.right > x) {
        ctx.fillStyle = String((dataset as { borderColor?: string }).borderColor ?? "#000");
        ctx.font = `${selectedFont.style} ${selectedFont.size}px ${selectedFont.family}`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        ctx.fillRect(
          x - width / 2 - padding,
          y - selectedFont.size / 2 - padding,
          width + 2 * padding,
          selectedFont.size + 2 * padding
        );

        ctx.fillStyle = "#ffffff";
        ctx.fillText(inclination, x, y);

        if (inclinationWarning) {
          ctx.fillStyle = "#ff0000";
          ctx.font = `${warningFont.style} ${warningFont.size}px ${warningFont.family}`;
          ctx.beginPath();
          ctx.arc(x + width / 2 + padding + 1, y - selectedFont.size / 2 - padding - 1, diameter, 0, 2 * Math.PI);
          ctx.fill();
          ctx.fillStyle = "#ffffff";
          ctx.fillText("!", x + width / 2 + padding + 1, y - selectedFont.size / 2 - padding + 0.25);
        }
      }
    });
  });
}
